import { Component } from '@angular/core';
import { AssociationDemoCertificationRenewalEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Certification Renewals') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-associationdemocertificationrenewal-form',
    templateUrl: './associationdemocertificationrenewal.form.component.html'
})
export class AssociationDemoCertificationRenewalFormComponent extends BaseFormComponent {
    public record!: AssociationDemoCertificationRenewalEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

